import styled, { css } from 'styled-components'

import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Tabs, Tab } from 'builder/components/Tabs'
import { TabSelector } from 'builder/components/Tabs/styles'

import { Media } from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};
`

export const Header = styled.h2`
  ${Typography.M};
  ${FontWeights.Medium};

  color: ${Colors.Neutral90};
`

export const TabsContainer = styled(Tabs)`
  gap: ${Spacing.L};

  ${TabSelector} {
    height: 3px;
  }

  ${Media.Phone`
    align-items: flex-end;
  `}
`

export const StyledTab = styled(Tab)`
  padding: ${Spacing.S} 0;
  margin-right: 0;

  ${({ isActive }) =>
    isActive &&
    css`
      ${FontWeights.Medium};
    `}

  ${Media.Phone`
    flex: 1;
    text-align: center;
  `}
`

export const CardsContainer = styled.div`
  display: flex;
  gap: 16px;
`

export const EmptyStateContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  position: relative;
`

export const Box = styled.div`
  flex: 1;
  height: 300px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f7f9fc 0%, rgba(247, 249, 252, 0) 83.96%);

  ${Media.Phone`
    height: 220px;
  `}
`

export const EmptyStateText = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  margin-top: 82px;

  ${Media.Phone`
    margin-top: 80px;
  `}
`

export const EmptyStateTitle = styled.h3`
  ${Typography.Body};
  ${FontWeights.Regular};

  color: ${Colors.Neutral90};
`

export const EmptyStateIcon = styled.img`
  width: 38px;
  height: 38px;
`
